


import React, { useState, useEffect } from "react";
import {
  Box, Grid, TextField, FormControl, InputLabel, Select, MenuItem,
  Checkbox, FormControlLabel, Typography, Button, Switch, Divider, Paper,
  FormHelperText,
} from "@mui/material";
import axios from "axios";
import { get, put } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import { authenticationService } from "src/services/authentication.service";
import { useParams, useNavigate } from 'react-router-dom';

interface EditUserProps {
  operatorId: string;          // Pass selected user ID to edit
  onClose: () => void;     // Close handler
  onSuccess: () => void;   // Callback on success
}

const API_URL = process.env.REACT_APP_BASE_API_URL;

const UpdateOwnerAccount: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    location: "",companyId: null, role: null, operatorName: "", email: "", password: "", mobile: "",
    phone: "", address1: "", address2: "", address3: "", postalCode: "", country: "India",
    state: "", zone: "", city: "", franchisees: [] as string[], selectAll: false,
    enableFreeAccess: false, allowNstvIrdCondition: false, allowLowBalanceRecharge: false, status: true,
    roleIdsList: [], franchiseIdsList: [], vendorId: null, franchiseId: null,IsOwnerAccount:true
  });
  
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [vendorsList, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  
  const franchiseeList = ["Franchisee A", "Franchisee B", "Franchisee C", "Franchisee D"];

  const { showSnackbar } = useSnackbar();
    const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();
      
      useEffect(() => {
        fetchVendors();
      }, []);




  // Fetch user data when editing
  useEffect(() => {
  const fetchOperator = async () => {
  try {
    setLoading(true);

    const response = await get(
      `${API_URL}/api/operators/vendor/${vendorId}/getByOperatorId`,
      { params: { id } }
    );

    const data = response?.data;


    setFormData({
      ...data, // ✅ VERY IMPORTANT
      roleIdsList: data.rolesList?.map(r => r.roleId) || [],
      franchiseIdsList: data.franchiseList?.map(f => f.franchise.id) || [],
      status: data.status === "ACTIVE",
      location: data.location || ""
    });

  } catch (error) {
    console.error("Error fetching operator:", error);
  } finally {
    setLoading(false);
  }
};


  if (id) fetchOperator();
}, [id]);



  // Fetch all states on load
    useEffect(() => {
      const fetchStates = async () => {
        try {
          const response = await get(`${API_URL}/states`);
          setStates(response || []);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };
      fetchStates();
    }, []);
  
    // Fetch cities based on selected state
    useEffect(() => {
      if (!formData.state) return;
      const fetchCities = async () => {
        setLoadingCities(true);
        try {
          const response = await get(`${API_URL}/cities?stateName=${formData.state}`);
          setCities(response || []);
        } catch (error) {
          console.error("Error fetching cities:", error);
          setCities([]);
        } finally {
          setLoadingCities(false);
        }
      };
      fetchCities();
    }, [formData.state]);
  
    const handleChange = (e: any) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
  
      
      setErrors((prev) => ({ ...prev, [name]: "" }));
    };

  
    const handleSwitchChange = (e: any) => {
      const { name, checked } = e.target;
      setFormData((prev) => ({ ...prev, [name]: checked }));
    };

  // const handleChange = (e: any) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };

  // const handleCheckboxChange = (franchisee: string) => {
  //   setFormData((prev) => {
  //     const isSelected = prev.franchisees.includes(franchisee);
  //     const updatedList = isSelected
  //       ? prev.franchisees.filter((f) => f !== franchisee)
  //       : [...prev.franchisees, franchisee];
  //     return { ...prev, franchisees: updatedList };
  //   });
  // };

  // const handleSelectAll = () => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     selectAll: !prev.selectAll,
  //     franchisees: prev.selectAll ? [] : [...franchiseeList],
  //   }));
  // };

  // const handleSwitchChange = (e: any) => {
  //   const { name, checked } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: checked }));
  // };

  const handleSubmit = async () => {
    if (!validate()) return; // stop submit if invalid
    try {
      setLoading(true);
      // formData.vendorId = vendorId;
      // formData.franchiseId = franchiseId;
      console.log('operatorId',id)
       const payload = {
        ...formData,
        id,
        status: formData.status ? 'ACTIVE' : 'INACTIVE',
      };
      const response = await put(`${API_URL}/api/operators/updateOwnerAccount/${id}`, payload);
      console.log('response',response)
      showSnackbar("updated Successfully", "success");
      navigate('/modules/OwnerAccounts');
      
    } catch (error) {
      console.error("Error updating user:", error);
      showSnackbar(  error?.response?.data?.message ||
      error?.message ||
      "Update failed" , "error");
     
    } finally {
      setLoading(false);
    }
  };

  const validate = () => {
    let tempErrors: { [key: string]: string } = {};

    if (!formData.vendorId) tempErrors.vendorId = "Vendor is required";
    //if (!formData.role) tempErrors.role = "Role is required";
    if (!formData.operatorName.trim()) tempErrors.operatorName = "Name is required";
   
    if (!formData.email) tempErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) tempErrors.email = "Enter a valid email";
    if (!formData.password) tempErrors.password = "Password is required";
    else if (formData.password.length < 6) tempErrors.password = "Password must be at least 6 characters";
    //if (formData.roleIdsList.length === 0) tempErrors.roleIdsList = "Select at least one role";

    //if (formData.franchiseIdsList.length === 0) tempErrors.franchiseIdsList = "Select at least one franchise";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  //const handleCancel = () => onClose();
  const handleCancel = () => {
    setFormData({
     location: "", companyId: null, role: null, operatorName: "", email: "", password: "", mobile: "",
      phone: "", address1: "", address2: "", address3: "", postalCode: "",
      country: "India", state: "", zone: "", city: "", franchisees: [],
      selectAll: false, enableFreeAccess: false, allowNstvIrdCondition: false,
      allowLowBalanceRecharge: false, status: true, franchiseIdsList: [], roleIdsList: [], vendorId: null, franchiseId: null, IsOwnerAccount:true
    });

     navigate('/modules/OwnerAccounts');
  };
  const handleRolesChange = (event) => {
      const { value } = event.target;

      setErrors((prev) => ({
      ...prev,
      roleIdsList: "",
    }));
  }

    // 🔹 Fetch Vendors (handles XML or JSON)
    const fetchVendors = async () => {
      try {
        const response = await get(`${API_URL}/api/vendors`);
  
        setVendors(response);
      } catch (err) {
        console.error('Error fetching vendors:', err);
        setError('Failed to load vendors.');
      }
    };

  return (
      <Box sx={{padding:'20px'}}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Update Owner Account Details
      </Typography>

      <Grid container spacing={2}>
        
        <Grid item xs={12} md={4}>
          <FormControl fullWidth  error={!!errors.vendorId}>
            <InputLabel id="vendor-label">Vendor</InputLabel>
            <Select
              labelId="vendor-label"
              name="vendorId"
              value={formData.vendorId}
              label="Vendor"
              onChange={handleChange}
            >
              {vendorsList.map((vendor) => (
                <MenuItem key={vendor.vendorId} value={vendor.vendorId}>
                  {vendor.vendorName}
                </MenuItem>
              ))}
            </Select>
            {errors.vendorId && <FormHelperText>{errors.vendorId}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={12} md={4}>
           <TextField
            label="Name"
            name="operatorName"
            fullWidth
            value={formData.operatorName}
            onChange={handleChange}
            error={!!errors.operatorName}
            helperText={errors.operatorName}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Phone" name="phone" fullWidth value={formData.phone} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="User Name" name="email" fullWidth value={formData.email} onChange={handleChange} error={!!errors.email}  helperText={errors.email} disabled/>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Password" name="password" type="password" fullWidth value={formData.password} onChange={handleChange} error={!!errors.password} helperText={errors.password} />
        </Grid>
        {/* <Grid item xs={12} md={4}>
          <TextField label="Address 1" name="address1" fullWidth value={formData.address1} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Address 2" name="address2" fullWidth value={formData.address2} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Address 3" name="address3" fullWidth value={formData.address3} onChange={handleChange} />
        </Grid> */}

        {/* <Grid item xs={12} md={4}>
           <FormControl fullWidth error={!!errors.state}>
            <InputLabel>State</InputLabel>
            <Select name="state" value={formData.state} onChange={handleChange}>
              {states.length > 0 ? (
                states.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No States Found</MenuItem>
              )}
            </Select>
            {errors.state && <FormHelperText>{errors.state}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.city}>
            <InputLabel>City</InputLabel>
            <Select
              name="city"
              value={formData.city}
              onChange={handleChange}
              disabled={!formData.state || loadingCities}
            >
              {loadingCities ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : cities.length > 0 ? (
                cities.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Cities Found</MenuItem>
              )}
            </Select>
            {errors.city && <FormHelperText>{errors.city}</FormHelperText>}
          </FormControl>
        </Grid> */}

        

        {/* <Grid item xs={12} md={3}>
          <FormControl fullWidth error={!!errors.country}>
            <InputLabel>Country</InputLabel>
            <Select name="country" value={formData.country} onChange={handleChange}>
              <MenuItem value="India">India</MenuItem>
              
            </Select>
            {errors.country && <FormHelperText>{errors.country}</FormHelperText>}
          </FormControl>
        </Grid> */}

        {/* <Grid item xs={12} md={3}>
          <TextField label="Postal Code" name="postalCode" fullWidth value={formData.postalCode} onChange={handleChange} />
        </Grid>
 */}
        {/* Switches */}
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={<Switch checked={formData.status} onChange={handleSwitchChange} name="status" />}
            label="Status (Active)"
          />
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button variant="contained" color="primary" sx={{ mr: 2 }} onClick={handleSubmit} >
            Update
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </Grid>
      </Grid>
   </Box>
  );
};

export default UpdateOwnerAccount;
